import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import CompanyListPanel from './CompanyListPanel';

function TaxPage({showToast,user}){
  var now=new Date();var defMonth=now.getFullYear()+'-'+('0'+(now.getMonth()+1)).slice(-2);
  var[yearMonth,setYearMonth]=useState(defMonth);
  var[taxData,setTaxData]=useState(null);
  var[loading,setLoading]=useState(false);
  var[checkedIds,setCheckedIds]=useState([]);
  var[sending,setSending]=useState(false);
  var[taxEmail,setTaxEmail]=useState('');
  var[sendWarnings,setSendWarnings]=useState([]);
  // 2026-05-22 — 강제 전송 시 sendType 기억 (1차 시도 → 1차 강제 / 최종 시도 → 최종 강제)
  var[lastSendType,setLastSendType]=useState('full');
  var isAdmin=user&&(user.role==='관리자'||user.role==='admin');
  var isDocAgency=user&&user.role==='doc_agency';
  var showCompanyFilter=isAdmin||isDocAgency;
  var[companies,setCompanies]=useState([]);
  var[filterCompanyId,setFilterCompanyId]=useState('');
  var[zipLoading,setZipLoading]=useState(false);
  var[xlsxLoading,setXlsxLoading]=useState(false);
  var[monthlyDocs,setMonthlyDocs]=useState([]);
  var[monthlyUploading,setMonthlyUploading]=useState(false);
  var[expandedTaxId,setExpandedTaxId]=useState(null); // 환급신고 상세 펼치기
  var[closeConfirm,setCloseConfirm]=useState(false);  // 신고마감 확인 팝업
  var[closing,setClosing]=useState(false);
  // 2026-05-26 — ZIP/메일 폴더 구조: 'car'(차량별) | 'docType'(서류 종류별). 세무사 요청. 선택 영속화.
  var[zipGroupBy,setZipGroupBy]=useState(localStorage.getItem('autodoc_tax_zip_groupby')||'car');
  var changeGroupBy=function(e){var v=e.target.value;localStorage.setItem('autodoc_tax_zip_groupby',v);setZipGroupBy(v);};

  var monthOptions=(function(){var a=[];for(var i=0;i<24;i++){var d=new Date(now.getFullYear(),now.getMonth()-i,1);a.push(d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2));}return a;})();

  useEffect(function(){if(isAdmin&&!isDocAgency){authFetch(API+'/admin/companies').then(function(r){return r.json()}).then(function(d){setCompanies(d||[])}).catch(function(){})}},[]);

  var loadTax=function(){setLoading(true);var url=API+'/tax/'+yearMonth;if(showCompanyFilter&&filterCompanyId)url+='?companyId='+filterCompanyId;authFetch(url).then(function(r){return r.json()}).then(function(d){setTaxData(d);setLoading(false);setCheckedIds([])}).catch(function(){setLoading(false)})};
  // 관세사 청구내역서 등 월별 첨부 (세무자료 ZIP/메일에 동봉)
  var loadMonthly=function(){var url=API+'/tax/monthly-docs/'+yearMonth;if(showCompanyFilter&&filterCompanyId)url+='?companyId='+filterCompanyId;authFetch(url).then(function(r){return r.json()}).then(function(d){setMonthlyDocs((d&&d.docs)||[])}).catch(function(){setMonthlyDocs([])})};
  useEffect(function(){loadTax();loadMonthly()},[yearMonth,filterCompanyId]);

  var cars=taxData?taxData.cars:[];
  var toggleCheck=function(id){setCheckedIds(function(p){return p.includes(id)?p.filter(function(x){return x!==id}):p.concat([id])})};

  // 서류 업로드 (범용)
  var uploadDoc=function(carId,docType){
    var inp=document.createElement('input');inp.type='file';inp.accept='image/*,.pdf';
    inp.onchange=function(){var f=inp.files[0];if(!f)return;var fd=new FormData();fd.append('file',f);fd.append('docType',docType);
      authFetch(API+'/cars/'+carId+'/upload-doc',{method:'POST',body:fd}).then(function(r){return r.json()}).then(function(d){if(d.success){showToast('업로드 완료');loadTax()}else{showToast('업로드 실패','err')}}).catch(function(){showToast('서버 오류','err')});
    };inp.click();
  };

  // 서류 다운로드 — CarList.downloadServerDoc 와 동일 패턴 (#116 후 {docType}_{carNo} 네이밍 + 인증 다운로드)
  var downloadDoc=function(carId,docType){
    authFetch(API+'/cars/'+carId+'/docs').then(function(r){return r.json()}).then(function(docs){
      // 새 파일명({docType}_{carNo}.ext) 호환 — exact 매칭 대신 prefix 매칭
      // 수출신고필증은 파일명이 myunjang_ 로 저장되는데 세무 화면 토큰은 export_declaration — 서버 ZIP 매처(routes/tax.js:397)와 동일한 alias 규칙
      var found=(docs||[]).find(function(d){var b=(d.fileName||'').split('.')[0];if(b===docType||b.startsWith(docType+'_'))return true;return docType==='export_declaration'&&(b==='myunjang'||b.startsWith('myunjang_'))});
      if(!found){showToast('파일 없음','err');return;}
      // 비-REALTIME 캐시서류: 200 JSON {url} → 상대경로는 authFetch blob(인증게이트 통과), 절대URL은 직링크.
      // REALTIME(malso/contract/nonbiz/pumui): 즉석 PDF buffer → blob.
      authFetch(API+'/cars/'+carId+'/docs/'+found.fileName).then(function(r2){
        var ct=(r2.headers&&r2.headers.get&&r2.headers.get('content-type'))||'';
        if(ct.indexOf('application/json')!==-1){
          return r2.json().then(function(j){
            if(!j||!j.url)return;
            if(j.url.charAt(0)==='/'){
              return authFetch(j.url).then(function(r3){return r3.blob()}).then(function(blob){var u=URL.createObjectURL(blob);var a=document.createElement('a');a.href=u;a.download=j.filename||found.fileName;a.click();URL.revokeObjectURL(u)});
            }
            var a=document.createElement('a');a.href=j.url;a.download=j.filename||found.fileName;a.click();
          });
        }
        return r2.blob().then(function(blob){var u=URL.createObjectURL(blob);var a=document.createElement('a');a.href=u;a.download=found.fileName;a.click();URL.revokeObjectURL(u)});
      }).catch(function(){showToast('다운로드 실패','err')});
    }).catch(function(){showToast('서버 오류','err')});
  };

  // 세무사 이메일 전송 (sendType: 'first' | 'full')
  var sendTax=async function(sendType,force){
    if(!taxEmail){showToast('세무사 이메일을 입력하세요','err');return;}
    // 미선택 기본값 = 이 달 신고대상만. (표에는 이월·이전달 합류분도 섞여 있어 cars 전체를 보내면
    //  세무사에게 신고 범위 밖 서류까지 나감 — 2026-07-25 마감일 컷오프 도입 후 명시적 지정)
    //  + 폐차(환급 제외) 차량은 항상 배제 (#258/#261).
    var _fallback=(taxData&&taxData.filing)?cars.filter(function(c){return c.filingTarget&&!isScrapExcl(c)}).map(function(c){return c.id})
                                           :cars.filter(function(c){return !isScrapExcl(c)}).map(function(c){return c.id});
    var ids=(checkedIds.length?checkedIds:_fallback).filter(function(id){var c=cars.find(function(x){return x.id===id});return !(c&&isScrapExcl(c));}); // 폐차 제외
    if(!ids.length){showToast('전송할 차량이 없습니다 (신고대상 0대)','err');return;}
    // 2026-05-22 — 강제 전송 시 sendType 보존 (force 가 아닐 때만 갱신)
    if(!force)setLastSendType(sendType);
    setSending(true);setSendWarnings([]);
    try{
      var resp=await authFetch(API+'/tax/send',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({month:yearMonth,toEmail:taxEmail,carIds:ids,force:!!force,sendType:sendType,groupBy:zipGroupBy})});
      var d=await resp.json();
      setSending(false);
      if(d.warnings&&d.warnings.length>0&&!d.success){setSendWarnings(d.warnings);showToast('누락 서류가 있습니다','err');return;}
      if(d.success){showToast((sendType==='first'?'1차 환급신청':'최종 서류')+' 전송 완료 (첨부 '+d.attachments+'건)');setSendWarnings([]);}
      else{showToast('전송 실패: '+(d.error||''),'err');}
    }catch(e){setSending(false);showToast('서버 오류','err');}
  };

  // ZIP 다운로드 — 5분 TTL 토큰 선발급 → <a href=...?token=...> native streaming
  // (blob 방식은 응답 전체 수신까지 대기하여 progressive download 차단 → 체감 느림.
  //  토큰 쿼리 파라미터로 인증 유지하며 브라우저 다운로드 매니저에 위임.)
  var downloadZip=function(){
    if(zipLoading)return;
    setZipLoading(true);
    var body={month:yearMonth};
    if(showCompanyFilter&&filterCompanyId)body.companyId=filterCompanyId;
    authFetch(API+'/tax/download-zip-token',{method:'POST',body:JSON.stringify(body)}).then(function(r){
      if(!r.ok)return r.json().then(function(j){throw new Error(j&&j.error?j.error:'토큰 발급 실패')});
      return r.json();
    }).then(function(d){
      if(!d||!d.token)throw new Error('토큰 없음');
      var zipUrl=API+'/tax/download-zip/'+yearMonth+'?token='+encodeURIComponent(d.token);
      if(showCompanyFilter&&filterCompanyId)zipUrl+='&companyId='+encodeURIComponent(filterCompanyId);
      zipUrl+='&groupBy='+encodeURIComponent(zipGroupBy);
      var a=document.createElement('a');a.href=zipUrl;a.download='tax_'+yearMonth+'.zip';a.click();
      setZipLoading(false);
    }).catch(function(e){showToast(e.message||'서버 오류','err');setZipLoading(false)});
  };

  // 폐차로 세무(환급/신고) 제외 판정 — 업체(세금계산서)=실제폐차(scrapDisposed), 개인(의제)=폐차장매입 포함(scrapExcluded).
  // 제외 차량은 흐리게+'폐차제외' 뱃지, 서류 충족 셀 숨김('-'), 세무사 전송 대상에서 배제.
  var isScrapExcl=function(c){var pt=c.purchaseType||'individual';var needTax=pt==='business'||pt==='individual_biz_tax';return needTax?!!c.scrapDisposed:!!c.scrapExcluded;};

  // 의제매입환급 신고자료 엑셀 다운로드 — 5분 TTL 토큰 → <a href=...?token=...> (주민번호 복호화 노출)
  var downloadXlsx=function(){
    if(xlsxLoading)return;
    setXlsxLoading(true);
    var body={month:yearMonth};
    if(showCompanyFilter&&filterCompanyId)body.companyId=filterCompanyId;
    authFetch(API+'/tax/export-xlsx-token',{method:'POST',body:JSON.stringify(body)}).then(function(r){
      if(!r.ok)return r.json().then(function(j){throw new Error(j&&j.error?j.error:'토큰 발급 실패')});
      return r.json();
    }).then(function(d){
      if(!d||!d.token)throw new Error('토큰 없음');
      var url=API+'/tax/export-xlsx/'+yearMonth+'?token='+encodeURIComponent(d.token);
      if(showCompanyFilter&&filterCompanyId)url+='&companyId='+encodeURIComponent(filterCompanyId);
      var a=document.createElement('a');a.href=url;a.download='수출차량_의제매입환급_'+yearMonth+'.xlsx';a.click();
      setXlsxLoading(false);
    }).catch(function(e){showToast(e.message||'서버 오류','err');setXlsxLoading(false)});
  };

  // 관세사 청구내역서 업로드 (월별, 업체별) — 재업로드 시 서버가 기존 대체
  var uploadMonthly=function(){
    if(showCompanyFilter&&!filterCompanyId){showToast('업체를 먼저 선택하세요','err');return;}
    var inp=document.createElement('input');inp.type='file';inp.accept='.pdf,image/*';
    inp.onchange=function(){var f=inp.files[0];if(!f)return;setMonthlyUploading(true);
      var fd=new FormData();fd.append('file',f);fd.append('month',yearMonth);if(showCompanyFilter&&filterCompanyId)fd.append('companyId',filterCompanyId);
      authFetch(API+'/tax/monthly-doc',{method:'POST',body:fd}).then(function(r){return r.json()}).then(function(d){setMonthlyUploading(false);if(d.success){showToast('청구내역서 업로드 완료');loadMonthly()}else{showToast(d.error||'업로드 실패','err')}}).catch(function(){setMonthlyUploading(false);showToast('서버 오류','err')});
    };inp.click();
  };
  var deleteMonthly=function(key){
    authFetch(API+'/tax/monthly-doc',{method:'DELETE',headers:{'Content-Type':'application/json'},body:JSON.stringify({key:key})}).then(function(r){return r.json()}).then(function(){loadMonthly()}).catch(function(){showToast('삭제 실패','err')});
  };
  var viewMonthly=function(key){
    authFetch(API+'/tax/monthly-doc/view?key='+encodeURIComponent(key)).then(function(r){return r.blob()}).then(function(blob){var u=URL.createObjectURL(blob);window.open(u,'_blank');setTimeout(function(){URL.revokeObjectURL(u)},60000)}).catch(function(){showToast('열기 실패','err')});
  };

  // ═══ 환급신고 마감 (2026-07-25) ═══
  // 마감 = "누른 날짜까지 선적 완료된 차량만 이번 달 신고, 나머지는 이월" 을 확정. 스냅샷으로 고정됨.
  var filing=(taxData&&taxData.filing)||null;
  var doClose=function(){
    if(closing)return;setClosing(true);
    var body={month:yearMonth};if(showCompanyFilter&&filterCompanyId)body.companyId=filterCompanyId;
    authFetch(API+'/tax/filing/close',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}).then(function(r){
      return r.json().then(function(j){if(!r.ok)throw new Error(j&&j.error?j.error:'마감 실패');return j});
    }).then(function(d){
      setClosing(false);setCloseConfirm(false);
      showToast(yearMonth+' 신고마감 완료 — 신고 '+d.count+'대 / 이월 '+d.carryCount+'대');
      loadTax();
    }).catch(function(e){setClosing(false);showToast(e.message||'서버 오류','err')});
  };
  var doReopen=function(){
    if(!window.confirm(yearMonth+' 마감을 취소할까요?\n확정된 신고 목록이 해제되고 다시 계산됩니다.'))return;
    var body={month:yearMonth};if(showCompanyFilter&&filterCompanyId)body.companyId=filterCompanyId;
    authFetch(API+'/tax/filing/reopen',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}).then(function(r){
      return r.json().then(function(j){if(!r.ok)throw new Error(j&&j.error?j.error:'마감 취소 실패');return j});
    }).then(function(){showToast('마감이 취소되었습니다');loadTax()}).catch(function(e){showToast(e.message||'서버 오류','err')});
  };

  // 서류 상태 셀
  var docCell=function(carId,docType,has,skip){
    if(skip) return(<td style={{textAlign:'center',color:'#94a3b8',fontSize:11}}>-</td>);
    if(has) return(<td style={{textAlign:'center',cursor:'pointer'}} onClick={function(){downloadDoc(carId,docType)}}><span style={{color:'#16a34a',fontWeight:700,fontSize:13}}>✓</span></td>);
    return(<td style={{textAlign:'center',cursor:'pointer'}} onClick={function(){uploadDoc(carId,docType)}}><span style={{color:'#dc2626',fontWeight:700,fontSize:13}}>✗</span></td>);
  };

  // 환급신고 배지 — 서류상태(statusBadge)와 별개. 선적 여부로 신고/이월이 갈린다.
  var filingBadge=function(c){
    if(!filing) return(<span style={{color:'#cbd5e1',fontSize:11}}>-</span>);
    if(c.filingTarget) return(<span style={{padding:'2px 8px',borderRadius:4,fontSize:10,fontWeight:700,background:'#dcfce7',color:'#166534'}}>{filing.closed?'신고확정':'신고대상'}</span>);
    if(c.filingCarry) return(<span title="선적이 확인되면 그 달 신고에 자동으로 포함됩니다" style={{padding:'2px 8px',borderRadius:4,fontSize:10,fontWeight:700,background:'#fef3c7',color:'#92400e'}}>이월</span>);
    return(<span style={{color:'#cbd5e1',fontSize:11}}>-</span>);
  };

  // 상태 배지
  var statusBadge=function(c){
    if(c.complete) return(<span style={{padding:'2px 8px',borderRadius:4,fontSize:10,fontWeight:700,background:'#dcfce7',color:'#166534'}}>완료</span>);
    if(c.isCarryOver) return(<span style={{padding:'2px 8px',borderRadius:4,fontSize:10,fontWeight:700,background:'#dbeafe',color:'#1e40af'}}>이월</span>);
    return(<span style={{padding:'2px 8px',borderRadius:4,fontSize:10,fontWeight:700,background:'#fef2f2',color:'#dc2626'}}>미비</span>);
  };

  return(<div style={{display:'flex',gap:16}}>
    {showCompanyFilter&&<CompanyListPanel user={user} context="tax" month={yearMonth} selectedCompanyId={filterCompanyId} onSelect={function(id){setFilterCompanyId(id)}} onSwitch={function(cid){authFetch(API+'/auth/switch-company',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({companyId:cid})}).then(function(r){return r.json()}).then(function(d){if(d.success&&d.token){localStorage.setItem('autodoc_token',d.token);sessionStorage.setItem('autodoc_user',JSON.stringify(d.user));window.location.reload()}}).catch(function(){})}}/>}
    <div style={{flex:1,minWidth:0}}>
    {/* 상단 월 선택 */}
    <div style={{display:'flex',gap:8,marginBottom:16,alignItems:'center',flexWrap:'wrap'}}>
      <select style={{padding:8,border:'1px solid #d0d5dd',borderRadius:8,fontWeight:700,fontSize:14}} value={yearMonth} onChange={function(e){setYearMonth(e.target.value)}}>
        {monthOptions.map(function(ym){return(<option key={ym} value={ym}>{ym}</option>)})}
      </select>
      {isAdmin&&<select style={{padding:8,border:'1px solid #d0d5dd',borderRadius:8,fontSize:13,color:'#1B3A5C',fontWeight:600}} value={filterCompanyId} onChange={function(e){setFilterCompanyId(e.target.value)}}>
        <option value="">전체 업체</option>
        {companies.map(function(c){return(<option key={c.id} value={c.id}>{c.name}</option>)})}
      </select>}
      <button className="btn btn-blue btn-sm" onClick={loadTax} disabled={loading}>{loading?'...':'새로고침'}</button>
      <span style={{display:'flex',alignItems:'center',gap:4,fontSize:12,color:'#64748b'}} title="ZIP 다운로드 및 세무사 메일 전송 시 폴더 구조">
        <span>폴더</span>
        <select style={{padding:'6px 8px',border:'1px solid #d0d5dd',borderRadius:8,fontSize:12,fontWeight:600,color:'#1B3A5C'}} value={zipGroupBy} onChange={changeGroupBy}>
          <option value="car">차량별</option>
          <option value="docType">서류 종류별</option>
        </select>
      </span>
      <button className="btn btn-sm" style={{background:zipLoading?'#94a3b8':'#475569',color:'#fff',border:'none',cursor:zipLoading?'wait':'pointer'}} onClick={downloadZip} disabled={zipLoading}>{zipLoading?'다운로드 준비 중...':'ZIP 다운로드'}</button>
      <button className="btn btn-sm" title="의제매입세액 환급 신고자료 (주민번호 포함)" style={{background:xlsxLoading?'#94a3b8':'#16794c',color:'#fff',border:'none',cursor:xlsxLoading?'wait':'pointer'}} onClick={downloadXlsx} disabled={xlsxLoading}>{xlsxLoading?'생성 중...':'📊 환급신고 엑셀'}</button>
      {filing&&(filing.closed
        ? <span style={{display:'inline-flex',alignItems:'center',gap:8,fontSize:12,background:'#f0fdf4',border:'1px solid #86efac',color:'#166534',borderRadius:8,padding:'6px 10px',fontWeight:700}}>
            ✅ {yearMonth} 마감완료 <span style={{fontWeight:400,color:'#15803d'}}>(선적 기준일 {filing.cutoff})</span>
            <span style={{cursor:'pointer',color:'#dc2626',fontWeight:700}} title="마감 취소" onClick={doReopen}>마감취소</span>
          </span>
        : <button className="btn btn-sm" title="이 달 환급신고 대상을 확정합니다" style={{background:'#b45309',color:'#fff',border:'none'}} onClick={function(){setCloseConfirm(true)}}>🔒 신고마감</button>)}
    </div>

    {/* 이전 달 미마감 경고 — 미마감이면 그 달 잔여분이 이 달로 합류하지 않아 신고 누락 가능 */}
    {filing&&filing.prevMonthOpen&&(<div style={{marginBottom:12,padding:'10px 12px',background:'#fffbeb',border:'1px solid #fcd34d',borderRadius:8,fontSize:12,color:'#92400e'}}>
      ⚠️ <b>{filing.prevMonth}</b>이 아직 마감되지 않았습니다. 이전 달을 먼저 마감해야 그 달의 미선적 차량이 이 달로 이월됩니다.
    </div>)}

    {/* 관세사 청구내역서 월별 첨부 (세무자료 ZIP/메일에 동봉) */}
    <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap',marginBottom:16,padding:'10px 12px',background:'#f8fafc',border:'1px solid #e2e8f0',borderRadius:8}}>
      <span style={{fontSize:13,fontWeight:700,color:'#1B3A5C'}}>📎 관세사 청구내역서</span>
      <span style={{fontSize:11,color:'#64748b'}}>(이 달 세무자료 ZIP/메일에 동봉 · 업체별 개별 업로드)</span>
      {monthlyDocs.length===0
        ? <span style={{fontSize:12,color:'#94a3b8'}}>첨부 없음</span>
        : monthlyDocs.map(function(d){return(<span key={d.key} style={{display:'inline-flex',alignItems:'center',gap:6,fontSize:12,background:'#fff',border:'1px solid #cbd5e1',borderRadius:6,padding:'3px 8px'}}>
            <span style={{cursor:'pointer',color:'#2563eb'}} onClick={function(){viewMonthly(d.key)}}>📄 청구내역서</span>
            <span style={{cursor:'pointer',color:'#dc2626',fontWeight:700}} title="삭제" onClick={function(){deleteMonthly(d.key)}}>✕</span>
          </span>)})}
      <button className="btn btn-sm" style={{background:monthlyUploading?'#94a3b8':'#0ea5e9',color:'#fff',border:'none',cursor:monthlyUploading?'wait':'pointer'}} onClick={uploadMonthly} disabled={monthlyUploading}>{monthlyUploading?'업로드 중...':(monthlyDocs.length?'🔄 교체 업로드':'+ 업로드')}</button>
    </div>

    {taxData&&(<>
      {/* 요약 통계 — 환급신고 기준(마감일 컷오프). 선적 안 된 차량은 신고대상에서 빠지고 이월된다.
          금액은 2칸으로 분리: 예상(이 달 말소분 전체) vs 실제 신고 가능(선적완료분). 차액 = 미선적분. */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(150px,1fr))',gap:12,marginBottom:16}}>
        <div className="stat-card"><div className="stat-info"><div className="stat-number">{taxData.total}</div><div className="stat-label">총 차량</div></div></div>
        <div className="stat-card"><div className="stat-info"><div className="stat-number" style={{color:'#16a34a'}}>{filing?filing.count:taxData.completeCount}</div><div className="stat-label">{filing?(filing.closed?'신고확정':'신고대상'):'서류 완비'}</div></div></div>
        <div className="stat-card"><div className="stat-info"><div className="stat-number" style={{color:'#b45309'}}>{filing?filing.carryCount:(taxData.carryOverCount||0)}</div><div className="stat-label">{filing?'이월(선적대기)':'이월'}</div></div></div>
        <div className="stat-card"><div className="stat-info"><div className="stat-number" style={{color:'#dc2626'}}>{taxData.missingCount}</div><div className="stat-label">서류 미비</div></div></div>
        <div className="stat-card" title="이 달 말소분 전체 기준 — 선적 여부와 무관한 잠재 환급액">
          <div className="stat-info"><div className="stat-number" style={{color:'#64748b'}}>{((filing?filing.expectedRefundTotal:taxData.estimatedRefund)||0).toLocaleString()}</div>
          <div className="stat-label">예상 환급액{filing?(' ('+(filing.count+filing.carryCount)+'대)'):''}</div></div></div>
        <div className="stat-card" title="마감일까지 선적이 완료돼 이번 달에 실제로 신고할 수 있는 금액">
          <div className="stat-info"><div className="stat-number" style={{color:'#16794c'}}>{((filing?filing.refundTotal:taxData.estimatedRefund)||0).toLocaleString()}</div>
          <div className="stat-label">{filing&&filing.closed?'신고 확정액':'신고 가능액'}{filing?(' ('+filing.count+'대)'):''}</div></div></div>
      </div>

      {/* 예상 − 신고가능 = 미선적분. 왜 차이가 나는지 한 줄로 못박아 준다. */}
      {filing&&filing.carryCount>0&&(<div style={{marginBottom:16,padding:'10px 12px',background:'#fffbeb',border:'1px solid #fde68a',borderRadius:8,fontSize:12.5,color:'#92400e',display:'flex',flexWrap:'wrap',alignItems:'center',gap:6}}>
        <span>💡</span>
        <span>예상 환급액 중 <b>{(filing.carryRefundTotal||0).toLocaleString()}원</b>({filing.carryCount}대)은 <b>아직 선적되지 않아</b> 이번 달 신고에서 빠집니다. 선적이 확인되는 달의 신고에 자동으로 합류합니다.</span>
      </div>)}

      {/* 차량별 서류 현황 테이블 */}
      <div className="card" style={{padding:10,marginBottom:16,overflowX:'auto'}}>
        <div style={{fontSize:11,color:'#64748b',marginBottom:8,display:'flex',alignItems:'center',gap:6}}>
          <span>ℹ️</span>
          <span>▸ 를 눌러 환급신고 상세(소유자·주소·면장번호 등)를 펼칠 수 있습니다. <b>주민번호는 화면에서 마스킹</b>되며, <b>환급신고 엑셀에는 실제 값이 적용</b>됩니다. 선적일자가 비정상이면 관세청 선적확인을 다시 실행해주세요.</span>
        </div>
        <table className="data-table" style={{minWidth:900}}>
          <thead><tr>
            <th style={{width:28}}><input type="checkbox" checked={checkedIds.length===cars.filter(function(c){return !isScrapExcl(c)}).length&&cars.some(function(c){return !isScrapExcl(c)})} onChange={function(e){if(e.target.checked){setCheckedIds(cars.filter(function(c){return !isScrapExcl(c)}).map(function(c){return c.id}))}else{setCheckedIds([])}}}/></th>
            <th style={{width:24}}></th>
            <th>차량번호</th><th style={{fontSize:10}}>차대번호</th><th>매입가</th><th style={{fontSize:11}}>명의자 지급</th>
            <th style={{textAlign:'right',fontSize:11}}>신고금액</th>
            <th style={{textAlign:'right',fontSize:11,color:'#16794c'}}>환급금액</th>
            <th style={{textAlign:'center',fontSize:11}}>매매계약서</th>
            <th style={{textAlign:'center',fontSize:11}}>말소증</th>
            <th style={{textAlign:'center',fontSize:11}}>세금계산서</th>
            <th style={{textAlign:'center',fontSize:11}}>비사업용</th>
            <th style={{textAlign:'center',fontSize:11}}>수출신고필증</th>
            <th style={{textAlign:'center',fontSize:11}}>구매확인서</th>
            <th style={{textAlign:'center',fontSize:11}} title="명의자 송금 증빙 — 세무신고 첨부자료로 동봉됩니다">입금증</th>
            <th style={{textAlign:'center',fontSize:11}}>면허일자</th>
            <th style={{textAlign:'center',fontSize:11}}>선적일자</th>
            <th style={{textAlign:'center',width:78,fontSize:11}}>신고</th>
            <th style={{textAlign:'center',width:70}}>상태</th>
          </tr></thead>
          <tbody>
            {cars.map(function(c){
              var pt=c.purchaseType||'individual';
              var needTax=pt==='business'||pt==='individual_biz_tax';
              var needNonbiz=pt==='individual_biz';
              var scrapX=isScrapExcl(c); // 폐차 → 환급 제외
              var bg=scrapX?'#f8fafc':(c.complete?'#f0fdf4':c.isCarryOver?'#eff6ff':'transparent');
              return(<React.Fragment key={c.id}>
              <tr style={{background:bg,opacity:scrapX?0.55:1}}>
                <td style={{textAlign:'center'}}><input type="checkbox" checked={checkedIds.includes(c.id)} disabled={scrapX} onChange={function(){toggleCheck(c.id)}}/></td>
                <td style={{textAlign:'center',cursor:'pointer',color:'#64748b',userSelect:'none',fontSize:12}} onClick={function(){setExpandedTaxId(expandedTaxId===c.id?null:c.id)}} title="상세 펼치기">{expandedTaxId===c.id?'▾':'▸'}</td>
                <td style={{fontWeight:700}}>{c.carNo||'-'}</td>
                <td className="mono" style={{fontSize:10}}>{(c.vin||'').substring(0,12)}...</td>
                <td style={{textAlign:'right'}}>{(c.buyPrice||0).toLocaleString()}</td>
                <td style={{textAlign:'right',color:'#2563eb'}}>{(c.ownerPayment||0).toLocaleString()}</td>
                <td style={{textAlign:'right'}}>{(c.declaredAmount||0).toLocaleString()}</td>
                <td style={{textAlign:'right',color:'#16794c',fontWeight:600}}>{(c.refundAmount||0).toLocaleString()}</td>
                {docCell(c.id,'contract',c.docs.contract,scrapX)}
                {docCell(c.id,'malsoCert',c.docs.malsoCert,scrapX)}
                {docCell(c.id,'tax_invoice',c.docs.tax_invoice,scrapX||!needTax)}
                {docCell(c.id,'nonbiz',c.docs.nonbiz,scrapX||!needNonbiz)}
                {docCell(c.id,'export_declaration',c.docs.export_declaration,scrapX||(!c.docs.export_declaration&&c.docs.purchase_confirm))}
                {docCell(c.id,'purchase_confirm',c.docs.purchase_confirm,scrapX||(!c.docs.purchase_confirm&&c.docs.export_declaration))}
                {/* #299 입금증 = 개인 매입(의제) 전용. 판정은 서버 단일 소스(depositApplicable) — 클라에 매입유형 규칙 복제 금지 */}
                {docCell(c.id,'deposit_receipt',c.docs.deposit_receipt,scrapX||!c.depositApplicable)}
                <td style={{textAlign:'center',fontSize:11}}>{c.licenseDate||'-'}</td>
                <td style={{textAlign:'center',fontSize:11}}>{c.shipDate||'-'}</td>
                <td style={{textAlign:'center'}}>{filingBadge(c)}</td>
                <td style={{textAlign:'center'}}>{scrapX?(<span style={{padding:'2px 8px',borderRadius:4,fontSize:10,fontWeight:700,background:'#fee2e2',color:'#dc2626'}}>폐차제외</span>):statusBadge(c)}</td>
              </tr>
              {expandedTaxId===c.id&&(<tr style={{background:'#f8fafc'}}>
                <td colSpan={19} style={{padding:'10px 16px',fontSize:12}}>
                  <div style={{display:'flex',flexWrap:'wrap',gap:'8px 24px',color:'#334155'}}>
                    <span><b>말소일자</b> {c.malsoDate||'-'}</span>
                    <span><b>연식</b> {c.yearVal||'-'}</span>
                    <span><b>구분</b> {c.sellerType||'-'}</span>
                    <span><b>소유자명</b> {c.ownerName||'-'}</span>
                    <span><b>주민(법인)번호</b> {c.ownerIdMasked||'-'} <span style={{color:'#94a3b8',fontSize:11}}>(엑셀엔 실제값 적용)</span></span>
                    <span style={{flexBasis:'100%'}}><b>주소</b> {c.ownerAddr||'-'}</span>
                    <span><b>면허금액</b> {(c.licenseAmount||0).toLocaleString()}</span>
                    <span><b>면장번호</b> {c.decNo||'-'}</span>
                  </div>
                </td>
              </tr>)}
              </React.Fragment>);
            })}
          </tbody>
        </table>
      </div>

      {/* 하단: 일괄 전송 */}
      <div className="card" style={{padding:16}}>
        <div style={{display:'flex',gap:8,alignItems:'center',flexWrap:'wrap',marginBottom:10}}>
          {filing&&<button className="btn btn-sm btn-outline" onClick={function(){setCheckedIds(cars.filter(function(c){return c.filingTarget&&!isScrapExcl(c)}).map(function(c){return c.id}))}}>신고대상만 선택 ({filing.count})</button>}
          <button className="btn btn-sm btn-outline" onClick={function(){setCheckedIds(cars.filter(function(c){return c.complete&&!isScrapExcl(c)}).map(function(c){return c.id}))}}>최종 완비만 선택</button>
          <span style={{fontSize:12,color:'#64748b'}}>{checkedIds.length?(checkedIds.length+'대 선택됨'):(filing?('미선택 시 신고대상 '+filing.count+'대 전송'):'')}</span>
        </div>
        <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:8}}>
          <input style={{flex:1,padding:8,border:'1px solid #d0d5dd',borderRadius:8,fontSize:12}} value={taxEmail} onChange={function(e){setTaxEmail(e.target.value)}} placeholder="세무사 이메일" type="email"/>
        </div>
        <div style={{display:'flex',gap:8}}>
          <button className="btn btn-blue" style={{flex:1,padding:10,borderRadius:8,fontSize:13,fontWeight:700}} onClick={function(){sendTax('full',false)}} disabled={sending}>
            {sending?'전송 중...':'최종 서류 전송'}
          </button>
        </div>
        <div style={{fontSize:11,color:'#94a3b8',marginTop:6}}>필수 서류: 매매계약서+말소증 (+ 업체 세금계산서) + 수출신고필증 또는 구매확인서 · 입금증은 개인 매입 차량만 선택(첨부 시 자동 동봉) · 세금계산서 매입(업체/개인사업자)은 입금증 불필요</div>
        {sendWarnings.length>0&&(<div style={{background:'#fef2f2',padding:10,borderRadius:8,marginTop:10,fontSize:11,color:'#dc2626'}}>
          <b>누락 서류:</b><br/>{sendWarnings.map(function(w,i){return(<div key={i}>- {w}</div>)})}
          <div style={{fontSize:10,color:'#92400e',marginTop:6}}>{lastSendType==='first'?'※ 1차 환급신청':'※ 최종 서류'}로 시도했습니다. 그래도 보낼까요?</div>
          <button className="btn btn-sm" style={{marginTop:8,background:'#dc2626',color:'#fff',border:'none',padding:'8px 14px',borderRadius:6,fontWeight:700,cursor:'pointer'}} onClick={function(){sendTax(lastSendType,true)}}>경고 무시하고 강제 전송 ({lastSendType==='first'?'1차':'최종'})</button>
        </div>)}
      </div>
    </>)}

    {/* 신고마감 확인 팝업 — 마감일이 곧 선적 커트라인이라는 점을 명확히 안내 */}
    {closeConfirm&&filing&&(<div style={{position:'fixed',inset:0,background:'rgba(15,23,42,.55)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}} onClick={function(){if(!closing)setCloseConfirm(false)}}>
      <div style={{background:'#fff',borderRadius:14,padding:'22px 24px',width:'min(520px,92vw)',boxShadow:'0 20px 50px rgba(0,0,0,.3)'}} onClick={function(e){e.stopPropagation()}}>
        <div style={{fontSize:17,fontWeight:800,color:'#1B3A5C',marginBottom:14}}>🔒 {yearMonth} 환급신고 마감</div>
        <div style={{fontSize:13,color:'#334155',lineHeight:1.75,marginBottom:14}}>
          오늘(<b>{filing.cutoff}</b>)까지 <b>선적이 완료된 {filing.count}대</b>만 이번 달 환급신고에 포함됩니다.<br/>
          아직 선적되지 않은 <b style={{color:'#b45309'}}>{filing.carryCount}대</b>는 이번 신고에서 제외되어 <b>다음 달로 이월</b>되며,
          선적이 확인되는 달의 신고 대상으로 자동 합류합니다.
        </div>
        <div style={{background:'#f8fafc',border:'1px solid #e2e8f0',borderRadius:10,padding:'12px 14px',marginBottom:14}}>
          <div style={{display:'flex',justifyContent:'space-between',fontSize:13,marginBottom:6}}>
            <span style={{color:'#166534',fontWeight:700}}>신고대상</span><span style={{fontWeight:800}}>{filing.count}대</span></div>
          <div style={{display:'flex',justifyContent:'space-between',fontSize:13,marginBottom:6}}>
            <span style={{color:'#b45309',fontWeight:700}}>이월(선적대기)</span><span style={{fontWeight:800}}>{filing.carryCount}대</span></div>
          <div style={{display:'flex',justifyContent:'space-between',fontSize:13,borderTop:'1px solid #e2e8f0',paddingTop:8}}>
            <span style={{color:'#1B3A5C',fontWeight:700}}>환급금액</span><span style={{fontWeight:800,color:'#16794c'}}>{(filing.refundTotal||0).toLocaleString()}원</span></div>
        </div>
        <div style={{fontSize:11,color:'#94a3b8',marginBottom:16}}>마감하면 이 달 신고 목록이 확정되어, 이후 선적일·금액이 바뀌어도 신고분은 변하지 않습니다. (필요 시 마감취소 가능)</div>
        <div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
          <button className="btn btn-sm btn-outline" onClick={function(){setCloseConfirm(false)}} disabled={closing}>취소</button>
          <button className="btn btn-sm" style={{background:closing?'#94a3b8':'#b45309',color:'#fff',border:'none',fontWeight:700,padding:'8px 18px'}} onClick={doClose} disabled={closing}>{closing?'마감 중...':'마감하기'}</button>
        </div>
      </div>
    </div>)}
  </div></div>);
}

export default TaxPage;
